import { render, staticRenderFns } from "./ChooseValuesSlide.vue?vue&type=template&id=48354f7f"
import script from "./ChooseValuesSlide.vue?vue&type=script&lang=js"
export * from "./ChooseValuesSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48354f7f')) {
      api.createRecord('48354f7f', component.options)
    } else {
      api.reload('48354f7f', component.options)
    }
    module.hot.accept("./ChooseValuesSlide.vue?vue&type=template&id=48354f7f", function () {
      api.rerender('48354f7f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/teacher/vue/slides/ChooseValuesSlide.vue"
export default component.exports